import {WebsiteSidebarSimpleItemBuilder} from "./website-sidebar-simple-item.builder";
import {IWebsiteSidebarSimpleItemData, WEBSITE_SIDEBAR_SIMPLE_ITEMS_DATA} from "./website-sidebar-simple-items-data";
import {WebsiteSidebarSimpleItem} from "./website-sidebar-simple-item.model";

export type WebsiteSidebarSimpleItemType =
  'mySites' | 'main' | 'credentials' | 'domains' | 'pointDomain' | 'tools' | 'redirects' | 'resource'
  | 'logs' | 'staging' | 'stagingEnabled' | 'manage' | 'builder' | 'recreate' | 'templates' | 'plugins' | 'themes'
  | 'backup' | 'seo' | 'imageOptimizer' | 'whiteLabel' | 'referralProgram' | 'boosterDisabled' | 'boosterMain'
  | 'boosterPages' | 'boosterMainDisabled' | 'boosterImageOptimizer' | 'boosterCloudflare' | 'boosterSettings' | 'boosterWhiteLabel'
  | 'boosterHostingPerformance' | 'boosterHostingPerformanceForHosted' | 'boosterPro' | 'boosterDisconnected' | 'boosterDisabledDev'
  | 'orders' | 'products' | 'customers' | 'paymentMethods' | 'analytics' | 'marketing' | 'payment' | 'shipping' | 'tax' | 'ecommerce' |
    'professional' | 'settings' | 'overview' | 'emails';

export class WebsiteSidebarSimpleItemDirector {
  static construct(type: WebsiteSidebarSimpleItemType): WebsiteSidebarSimpleItem {
    if (!WEBSITE_SIDEBAR_SIMPLE_ITEMS_DATA[type]) {
      throw new Error(`cannot construct "Sidebar Item" of type ${type}`);
    }
    const data: IWebsiteSidebarSimpleItemData = WEBSITE_SIDEBAR_SIMPLE_ITEMS_DATA[type];
    const product: WebsiteSidebarSimpleItemBuilder = new WebsiteSidebarSimpleItemBuilder(data.name, data.label);
    if (data.img) {
      product.setImg(data.img);
    }
    if (data.icon) {
      product.setIcon(data.icon);
    }
    if (data.path) {
      product.setPath(data.path);
    }
    if (data.actions) {
      product.setActions(data.actions);
    }
    if (data.disabled) {
      product.setDisabled(data.disabled);
    }
    if (data.hidden) {
      product.setDisabled(data.hidden);
    }
    if (data.notification) {
      product.setNotification(data.notification);
    }
    if (data.beta) {
      product.setBeta(data.beta);
    }
    if (data.externalLink) {
      product.setExternalLink(data.externalLink);
    }
    if (data.showUpgrade) {
      product.setShowUpgrade(data.showUpgrade);
    }
    return product.build();
  }
}
